export default __webpack_public_path__ + "static/media/11.6a9152f4.svg";